













import Vue from 'vue'
import { CHART_SIZE } from '../sizes'

export default Vue.extend({
  name: 'AxisY2Title',
  data: () => ({ CHART_SIZE }),
})
